import { k as k$1, c as c$1, b, q, r, x } from './chunk-6O5I75HI.js';
import { e, c } from './chunk-EU5NKIY3.js';
import { f } from './chunk-UTFXT4BW.js';
import { g as g$1 } from './chunk-RETI4LME.js';
import V, { css, useTheme } from 'styled-components';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as Y from 'react';
import Y__default, { forwardRef, createContext, memo, useContext, useRef, useEffect, useState, useCallback, cloneElement, useMemo, useLayoutEffect } from 'react';
import { Link } from '@sevenrooms/navigation';
import { transparentize, darken } from 'polished';
import { useSelect } from 'downshift';
import Le from 'react-merge-refs';
import { defineMessages, useLocales, commonMessages } from '@sevenrooms/locales';
import ur from 'css-time';
import we from 'react-scrolllock';
import or from 'dom-css';
import We from 'lodash';
import { Transition } from 'react-transition-group';
import { createPortal } from 'react-dom';
import { useMediaQuery } from '@sevenrooms/react-components/hooks/useMediaQuery';

function ni({children:e,disabled:t,target:o="_blank",...n}){return jsx(Yt,{...n,target:o,color:"primaryButton",disabled:t,children:e})}var Yt=V.a`
  text-decoration: none;
  font-family: ${e=>e.theme.fonts.primary};
  color: ${e=>e.theme.colors.primaryButton};
  cursor: pointer;
  &:hover {
    color: ${e=>e.theme.colors.primaryHover};
  }

  &:focus {
    color: ${e=>e.theme.colors.primaryHover};
  }

  &:visited {
    color: ${e=>e.theme.colors.primaryButton};
  }

  ${e=>e.textStyle&&css`
      font: ${e.theme.textStyles[e.textStyle]} !important;
    `}

  ${e=>e.disabled&&css`
      color: ${t=>t.theme.colors.deactivated};
      cursor: not-allowed;
      pointer-events: none;

      &:hover {
        color: ${t=>t.theme.colors.deactivated};
      }

      &:focus {
        color: ${t=>t.theme.colors.deactivated};
      }

      &:visited {
        color: ${t=>t.theme.colors.deactivated};
      }
    `}
`;function Zt({color:e="primaryFont",type:t="span",fontWeight:o="normal",fontSize:n="m",fontStyle:i="normal",lineHeight:r="s",whiteSpace:a,wordBreak:s,...l},u){return jsx(qt,{as:t,color:e,fontWeight:o,fontStyle:i,fontSize:n,lineHeight:r,whiteSpace:a,wordBreak:s,...l,ref:u})}var y=Y.forwardRef(Zt),qt=V.span`
  font-family: ${e=>e.theme.fonts.primary} !important;
  line-height: ${e=>e.lineHeight?e.theme.lineHeights[e.lineHeight]:e.theme.lineHeights.s} !important;
  color: ${e=>e.color?e.color==="inherit"?"inherit":e.theme.colors[e.color]:e.theme.colors.primaryFont} !important;
  font-style: ${e=>e.fontStyle} !important;
  font-weight: ${e=>e.fontWeight} !important;
  font-size: ${e=>e.fontSize?e.theme.fontSizes[e.fontSize]:e.theme.fontSizes.m} !important;
  width: ${e=>e.width};
  max-width: ${e=>e.maxWidth};
  display: ${e=>e.textDisplay};
  justify-content: ${e=>e.justifyContent};
  cursor: ${e=>e.cursor};

  ${e=>e.textStyle&&css`
      font: ${e.theme.textStyles[e.textStyle]} !important;
    `}
  ${e=>e.whiteSpace&&css`
      white-space: ${e.whiteSpace};
    `}
  ${e=>e.textDecoration&&css`
      text-decoration: ${e.textDecoration};
    `}
  ${e=>e.textTransform&&css`
      text-transform: ${e.textTransform};
    `}
  ${e=>e.textOverflow&&(e.textOverflow==="ellipsis"&&Ye||e.textOverflow==="twoLinesEllipsis"&&Qt||typeof e.textOverflow=="number"&&Ue(e.textOverflow))}

  ${e=>e.textAlign&&css`
      text-align: ${e.textAlign};
    `}

    ${e=>e.overflowWrap&&css`
      overflow-wrap: ${e.overflowWrap};
    `}

  ${e=>e.wordBreak&&css`
      word-break: ${e.wordBreak};
    `}

  ${e=>e.letterSpacing&&css`
      letter-spacing: ${e.theme.letterSpacing[e.letterSpacing]};
    `}

  ${e=>e.lineBreak&&css`
      line-break: ${e.lineBreak};
    `}
`,Ye=css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`,Ue=e=>css`
  ${Ye}

  @supports (-webkit-line-clamp: ${e}) {
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: ${e};
    -webkit-box-orient: vertical;
  }
`,Qt=Ue(2);function pi(e){return jsx(y,{...e,color:"error",textStyle:"error"})}function eo(e,t){return jsx(y,{...e,color:"secondaryFont",ref:t})}var $i=Y__default.forwardRef(eo);function ro({type:e="h3",children:t,...o},n){return jsx(no,{...o,ref:n,type:e,textStyle:e,children:t})}var no=V(y)`
  margin: 0; // removes default margins styles inherited from the browser

  ${e=>e.ml&&css`
      margin-left: ${e.theme.spacing[e.ml]};
    `}

  ${e=>e.mr&&css`
      margin-right: ${e.theme.spacing[e.mr]};
    `}

    ${e=>e.mt&&css`
      margin-top: ${e.theme.spacing[e.mt]};
    `}

    ${e=>e.mb&&css`
      margin-bottom: ${e.theme.spacing[e.mb]};
    `}
`,Ze=Y.forwardRef(ro);function qe(e){return jsx(so,{...e})}var so=V(Link)`
  color: inherit !important;
  text-decoration: none !important;
`;function _i({color:e,fontSize:t,lineHeight:o,fontWeight:n,fontStyle:i,whiteSpace:r,textDecoration:a,children:s,disabled:l,textStyle:u,...c}){return jsx(qe,{...c,children:jsx(po,{type:"span",color:e||"linkColor",fontSize:t,lineHeight:o,fontWeight:n,fontStyle:i,textDecoration:a,whiteSpace:r,disabled:l,textStyle:u,children:s})})}var po=V(y)`
  &:hover {
    color: ${e=>e.theme.colors.primaryHover};
  }

  &:focus {
    color: ${e=>e.theme.colors.primaryHover};
  }

  &:visited {
    color: ${e=>e.theme.colors.primaryButton};
  }

  ${e=>e.disabled&&css`
      color: ${t=>t.theme.colors.deactivated};
      cursor: not-allowed;
      pointer-events: none;

      &:hover {
        color: ${t=>t.theme.colors.deactivated};
      }

      &:focus {
        color: ${t=>t.theme.colors.deactivated};
      }

      &:visited {
        color: ${t=>t.theme.colors.deactivated};
      }
    `}
`;function Ki(e){return jsx(ho,{as:e.variant==="ordered"?"ol":"ul",spacing:e.spacing,type:e.type,children:e.children})}var ho=V.ul`
  padding-left: 16px !important;
  margin: 0;

  li:not(:last-child) {
    // important is necessary for overriding global styles on manager settings pages
    margin-bottom: ${e=>e.theme.spacing[e.spacing??"s"]} !important;
  }
  li {
    list-style: inherit;
  }
`;function ea(e){return jsx("li",{children:e.children})}function yo({children:e,...t}){return jsx($o,{...t,type:"p",children:e})}var $o=V(y)`
  margin-top: 0;
  margin-bottom: ${e=>e.theme.spacing.sm};
`,sa=yo;function To(e,t){return jsx(Co,{...e,ref:t,as:e.as??"div"})}var g=Y.forwardRef(To),Co=V.div`
  box-sizing: border-box;
  text-align: ${e=>e.textAlign||"left"};

  ${e=>e.display!==undefined&&css`
      display: ${e.display};
    `}

  ${e=>e.visibility!==undefined&&css`
      visibility: ${e.visibility};
    `}

  ${e=>e.width!==undefined&&css`
      width: ${e.width};
    `}

  ${e=>e.height!==undefined&&css`
      height: ${e.height};
    `}

  ${e=>e.minHeight!==undefined&&css`
      min-height: ${e.minHeight};
    `}

  ${e=>e.minWidth!==undefined&&css`
      min-width: ${e.minWidth};
    `}

  ${e=>e.maxWidth!==undefined&&css`
      max-width: ${e.maxWidth};
    `}

  ${e=>e.maxHeight!==undefined&&css`
      max-height: ${e.maxHeight};
    `}

  ${e=>e.overflow!==undefined&&css`
      overflow: ${e.overflow};
    `}

  ${e=>e.overflowX!==undefined&&css`
      overflow-x: ${e.overflowX};
    `}

  ${e=>e.overflowY!==undefined&&css`
      overflow-y: ${e.overflowY};
    `}

  ${e=>e.boxSizing!==undefined&&css`
      box-sizing: ${e.boxSizing};
    `}

  ${e=>e.backgroundColor!==undefined&&css`
      background-color: ${e.theme.colors[e.backgroundColor]};
    `}

  ${e=>e?.backgroundImage!==undefined&&css`
      background-image: url(${e.backgroundImage});
      background-size: cover;
    `}

  ${e=>e.borderRadius!==undefined&&css`
      border-radius: ${Ro(e,e.borderRadius)};
    `}

  ${e=>e.borderTopLeftRadius!==undefined&&css`
      border-top-left-radius: ${e.theme.borderRadius[e.borderTopLeftRadius]};
    `}

  ${e=>e.borderTopRightRadius!==undefined&&css`
      border-top-right-radius: ${e.theme.borderRadius[e.borderTopRightRadius]};
    `}
  ${e=>e.borderBottomLeftRadius!==undefined&&css`
      border-bottom-left-radius: ${e.theme.borderRadius[e.borderBottomLeftRadius]};
    `}

  ${e=>e.borderBottomRightRadius!==undefined&&css`
      border-bottom-right-radius: ${e.theme.borderRadius[e.borderBottomRightRadius]};
    `}

  ${e=>e.borderColor!==undefined&&css`
      border: ${K(e,e.borderColor)};
    `}

  ${e=>e.borderTopColor!==undefined&&css`
      border-top: ${K(e,e.borderTopColor)};
    `}

  ${e=>e.borderBottomColor!==undefined&&css`
      border-bottom: ${K(e,e.borderBottomColor)};
    `}

  ${e=>e.borderLeftColor!==undefined&&css`
      border-left: ${K(e,e.borderLeftColor)};
    `}

  ${e=>e.borderRightColor!==undefined&&css`
      border-right: ${K(e,e.borderRightColor)};
    `}

  ${e=>e.borderWidth!==undefined&&css`
      border-width: ${e.theme.borderWidth[e.borderWidth]};
    `}

  ${e=>e.lineClamp!==undefined&&css`
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: ${e.lineClamp};
      -webkit-box-orient: vertical;
    `}

  ${e=>e.position!==undefined&&css`
      position: ${e.position};
    `}

  ${e=>e.top!==undefined&&css`
      top: ${e.theme.spacing[e.top]};
    `}

  ${e=>e.bottom!==undefined&&css`
      bottom: ${e.theme.spacing[e.bottom]};
    `}

  ${e=>e.left!==undefined&&css`
      left: ${e.theme.spacing[e.left]};
    `}

  ${e=>e.right!==undefined&&css`
      right: ${e.theme.spacing[e.right]};
    `}

  ${e=>e.boxShadow!==undefined&&css`
      box-shadow: ${e.theme.shadows[e.boxShadow]};
    `}

  ${e=>e.zIndex!==undefined&&css`
      z-index: ${typeof e.zIndex=="number"?e.zIndex:e.theme.zIndex[e.zIndex]};
    `}

  ${e=>e.cursor!==undefined&&css`
      cursor: ${e.cursor};
    `}

  ${e=>e.gridColumn!==undefined&&css`
      grid-column: ${e.gridColumn};
    `}

  ${e=>e.gridColumnStart!==undefined&&css`
      grid-column-start: ${e.gridColumnStart};
    `}

  ${e=>e.gridRowStart!==undefined&&css`
      grid-row-start: ${e.gridRowStart};
    `}

  ${e=>"p"in e?css`
          padding: ${C(e,e.p)};
        `:css`
          padding-top: ${C(e,e.pt)};
          padding-right: ${C(e,e.pr)};
          padding-bottom: ${C(e,e.pb)};
          padding-left: ${C(e,e.pl)};
        `}

  ${e=>"m"in e?css`
          margin: ${C(e,e.m)};
        `:css`
          margin-top: ${C(e,e.mt)};
          margin-right: ${C(e,e.mr)};
          margin-bottom: ${C(e,e.mb)};
          margin-left: ${C(e,e.ml)};
        `}
`;function C(e,t){return t?Je(t,o=>o==="auto"?"auto":e.theme.spacing[o]):0}function K(e,t){return `${e.theme.borderWidth.s} solid ${e.theme.colors[t]}`}function Ro(e,t){return Je(t,o=>e.theme.borderRadius[o])}function Je(e,t){return e.split(" ").map(o=>t(o)).join(" ")}function ga(e){return jsx(g,{...e,pl:"xs",ml:"lm"})}function Ta(e){return jsx(g,{...e,width:"220px"})}function Lo(e,t){return jsx(Mo,{...e,ref:t,as:e.as})}var M=Y.forwardRef(Lo),Mo=V(g)`
  display: ${e=>e.display||(e.inline?"inline-flex":"flex")};
  flex-direction: ${e=>e.flexDirection};
  align-items: ${e=>e.alignItems};
  justify-content: ${e=>e.justifyContent};
  flex-wrap: ${e=>e.flexWrap};
  flex-basis: ${e=>e.flexBasis};
  flex-grow: ${e=>e.flexGrow};
  flex-shrink: ${e=>e.flexShrink};
  justify-self: ${e=>e.justifySelf};
  align-self: ${e=>e.alignSelf};
  flex: ${e=>e.flex};

  ${e=>e.width&&css`
      width: ${typeof e.width=="string"?e.width:`${e.width}px`};
    `}

  ${e=>e.height&&css`
      height: ${typeof e.height=="string"?e.height:`${e.height}px`};
    `}


    ${e=>e.rowGap&&css`
      row-gap: ${C(e,e.rowGap)};
    `}

    ${e=>e.columnGap&&css`
      column-gap: ${C(e,e.columnGap)};
    `}
`;function Ga({"data-test":e$1,children:t,variant:o}){return jsxs(Eo,{"data-test":e$1,justifyContent:"center",alignItems:"baseline",children:[jsx(g,{children:jsx(e,{name:"VMSWeb-checkbox-filled",color:o,size:"sm"})}),t&&jsx(g,{children:jsx(y,{color:"secondaryFont",textTransform:"uppercase",fontSize:"xs",children:t})})]})}var Eo=V(M)`
  font-size: ${e=>e.theme.fontSizes.xs};
  font-family: ${e=>e.theme.fonts.primary};
  letter-spacing: ${e=>e.theme.spacing.xxs};
`;function Ja({"data-test":e$1,...t}){let o=Y.useMemo(()=>{switch(t.kind){case "warning":return "warning";case "error":return "error";case "success":return "successText";default:return "warning"}},[t.kind]);return jsxs(M,{"data-test":e$1,inline:true,alignItems:"center",children:[jsx(e,{name:t.icon??"VMSWeb-warning",color:t.kind}),jsx(g,{ml:"xs",children:jsx(y,{color:o,fontWeight:"bold",children:t.children})})]})}function Ao({label:e$1,multiValue:t,selected:o,wrapText:n,description:i,...r},a){return jsxs(Oo,{ref:a,multiValue:t,selected:o,wrapText:n,flexDirection:i?"column":"row",...r,children:[jsxs("span",{children:[t&&jsx(e,{size:"lg",color:o?"primaryButton":"primaryIcons",name:o?c["VMSWeb-check-box"]:c["VMSWeb-check-box-outline-blank"]}),e$1]}),i]})}var Oo=V.li`
  user-select: none;
  background: ${e=>e.highlighted?e.theme.colors.margin:e.theme.colors.primaryBackground};
  padding: ${e=>e.theme.spacing.s};
  display: flex;
  flex-direction: ${e=>e.flexDirection};
  align-items: flex-start;
  min-width: 0;

  i {
    margin: 0px 5px 0px 0px;
    padding: 1px 0px;
  }

  span {
    width: 100%;
    line-height: 18px;
    color: ${e=>e.theme.colors.primaryFont};
    font-size: ${e=>e.theme.fontSizes.m};
    font-family: ${e=>e.theme.fonts.primary};
    font-weight: ${e=>e.multiValue||!e.selected?400:700};
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: ${e=>e.wrapText?"pre-wrap":"nowrap"};
    overflow: hidden;
  }

  span:empty {
    height: 18px;
  }
`,ot=V.li`
  pointer-events: none;
  user-select: none;
  padding: ${e=>e.theme.spacing.s};
  line-height: 18px;
  color: ${e=>e.theme.colors.secondaryFont};
  font-size: ${e=>e.theme.fontSizes.m};
  font-family: ${e=>e.theme.fonts.primary};
  font-weight: 400;
  box-sizing: border-box;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`,rt=V.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  outline: none;
  overflow-y: scroll;
  max-height: 252px;
  border: 1px solid ${e=>e.theme.colors.deactivated};
  border-radius: ${e=>{let t=e.theme.borderRadius.s;return e.flipped?`${t} ${t} 0 0`:`0 0 ${t} ${t}`}};
  background: ${e=>e.theme.colors.primaryBackground};
  box-shadow: 0 4px 8px rgba(9, 34, 56, 0.1);
  width: ${e=>e.width}px;
  box-sizing: content-box;
`,nt=forwardRef(Ao);var it="default"in we?we.default:we;function lt({index:e=f.zIndex.default,children:t}){let o=useContext(at),n=Math.max(o,e),i=n+1;return jsx(at.Provider,{value:i,children:t(n)})}var at=createContext(f.zIndex.default);function st({children:e}){let t=useRef(null);return t.current||(t.current=Xo()),useEffect(()=>()=>{t.current&&dt().removeChild(t.current);},[]),t.current?createPortal(e,t.current):null}function Xo(){if(typeof window<"u"&&typeof window.document<"u"){let e=document.createElement("div");return dt().appendChild(e),e}return null}function Zo(){return G=document.createElement("div"),G.setAttribute("role","complementary"),G.setAttribute("data-test-id","ui-portal-container"),document.body.appendChild(G),G}var G=null;function dt(){return G??Zo()}function ct(e,t,o,n,i,r,a=true){let{alignment:s,rect:l}=qo(e,t,o,n,i,r,a);if(a){if(l.left<r&&(l.right+=Math.ceil(Math.abs(l.left-r)),l.left=Math.ceil(r)),l.right>i.width-r){let c=Math.ceil(l.right-(i.width-r));l.left-=c,l.right-=c;}if(l.top<r&&(l.top+=Math.ceil(Math.abs(l.top-r)),l.bottom=Math.ceil(r)),l.bottom>i.height-r){let c=Math.ceil(l.bottom-(i.height-r));l.top-=c,l.bottom-=c;}}let u=ut(e)?o.top+o.height/2:o.left+o.width/2;return {alignment:s,rect:l,transformOrigin:Qo(l,s,t,u)}}function qo(e,t,o,n,i,r,a=true){if(ut(e)){let f=ae("left",t,o,n),P=ae("right",t,o,n),T=!a||Jo(f,r),x=!a||er(P,i,r);if(e==="left"){if(T)return {alignment:e,rect:f};if(x)return {alignment:"right",rect:P}}if(e==="right"){if(x)return {alignment:e,rect:P};if(T)return {alignment:"left",rect:f}}let v=Math.abs(i.width-r-P.right),w=Math.abs(f.left-r);return v<w?{alignment:"right",rect:P}:{alignment:"left",rect:f}}let s=mt(e),l=ae(s?e:_(e),t,o,n),u=ae(s?_(e):e,t,o,n),c=!a||Ko(l,r),m=!a||jo(u,i,r);if(s){if(c)return {alignment:e,rect:l};if(m)return {alignment:_(e),rect:u}}else {if(m)return {alignment:e,rect:u};if(c)return {alignment:_(e),rect:l}}let p=Math.abs(i.height-r-u.bottom),h=Math.abs(l.top-r);return p<h?{alignment:s?_(e):e,rect:u}:{alignment:s?e:_(e),rect:l}}function Qo(e,t,o,n){let i=Math.round(n-e.top),r=Math.round(n-e.left);return t==="left"?`${o.width}px ${i}px`:t==="right"?`0px ${i}px`:mt(t)?`${r}px ${o.height}px`:`${r}px 0px`}function ae(e,t,o,n){let i=o.left+o.width/2-t.width/2,r=o.top-t.height-n,a=o.bottom+n,s=o.right-t.width,l=o.top+o.height/2-t.height/2;switch(e){case "left":return W(t,{top:l,left:o.left-t.width-n});case "right":return W(t,{top:l,left:o.right+n});case "top":return W(t,{top:r,left:i});case "topLeft":return W(t,{top:r,left:o.left});case "topRight":return W(t,{top:r,left:s});case "bottomLeft":return W(t,{top:a,left:o.left});case "bottomRight":return W(t,{top:a,left:s});default:return W(t,{top:a,left:i})}}function W({width:e,height:t},{left:o,top:n}){let i=Math.ceil(o),r=Math.ceil(n);return {width:e,height:t,left:i,top:r,right:i+e,bottom:r+t}}var mt=e=>e.startsWith("top"),ut=e=>e==="left"||e==="right",Ko=(e,t)=>e.top>t,Jo=(e,t)=>e.left>t,jo=(e,t,o)=>e.bottom<t.height-o,er=(e,t,o)=>e.right<t.width-o,_=e=>tr[e]||"bottom",tr={top:"bottom",topLeft:"bottomLeft",topRight:"bottomRight",bottom:"top",bottomLeft:"topLeft",bottomRight:"topRight"};function ar(e){let t=useTheme(),{show:o,target:n,children:i,animationDuration:r}=e,a=k$1(),s=c$1(),l=b(e),u=useRef(null),c=useRef(null),m=useRef(null);return m.current||(m.current=lr(l,u,c,s,a)),jsx(lt,{index:t.zIndex.popover,children:p=>jsxs(Fragment,{children:[n({ref:u,flipped:!!m.current?.state.flipped,show:o}),jsx(Transition,{in:o&&m.current?.state.visible,appear:true,timeout:r,onEnter:m.current?.onEnter,onEntered:m.current?.onEntered,onExited:m.current?.onExited,unmountOnExit:true,children:h=>jsx(st,{children:i({ref:c,flipped:!!m.current?.state.flipped,state:h,zIndex:p})})})]})})}var ft={left:0,top:0,height:0,width:0,transformOrigin:undefined};function lr(e,t,o,n,i){let r={style:{...ft},flipped:false,visible:true};function a(p,h){return e()[p]??h}function s(p){let h=p.childNodes.item(0);if(p.getAttribute("data-state")==="entered"){let f=h.getBoundingClientRect();return {height:Math.round(f.height),width:Math.round(f.width)}}return {height:Math.max(h.offsetHeight,r.style.height),width:Math.max(h.offsetWidth,r.style.width)}}function l(p,h,f){return ct(p,h,f,a("targetOffset",8),{height:document.documentElement.clientHeight,width:document.documentElement.clientWidth},a("bodyOffset",8),a("useSmartAlignment",true))}function u(){if(t.current&&o.current){let p=a("alignment","bottom"),h=s(o.current),f=t.current.getBoundingClientRect(),{alignment:P,rect:T,transformOrigin:x}=l(p,h,f),v=P!==p,w=sr(f);(r.visible!==w||r.flipped!==v)&&(r.visible=w,r.flipped=v,i());let A=r.style;return r.style={top:T.top,left:T.left,...h,transformOrigin:x},dr(A,r.style)}return  false}let c=null;function m(){c=null,e().show&&!n.current&&o.current&&(u()&&or(o.current,r.style),c=requestAnimationFrame(m));}return {state:r,onEnter:m,onEntered(){a("onOpenComplete",We.noop)();},onExited(){c&&(cancelAnimationFrame(c),c=null),r.style={...ft},r.visible=true,r.flipped=false,i(),a("onCloseComplete",We.noop)();}}}function sr(e){return e.top>=-e.height&&e.left>=-e.width&&e.top<=document.documentElement.clientHeight&&e.left<=document.documentElement.clientWidth}function dr(e,t){return e.top!==t.top||e.left!==t.left||e.height!==t.height||e.width!==t.width||e.transformOrigin!==t.transformOrigin}var ht=memo(ar);function yr({show:e,initiallyShow:t,alignment:o="bottom",useSmartAlignment:n,targetOffset:i,bodyOffset:r,children:a,content:s,contentProps:l,shouldCloseOnClick:u,shouldCloseOnBodyClick:c,shouldCloseOnEscapeKey:m,captureCloseClick:p,zIndexLayer:h="popover",scrollLock:f,"data-test":P,...T}){let[x,v]=useState(!!t),w=useRef(null),A=useRef(null),E=b(T),N=useCallback(()=>{x||(v(true),E().onOpen?.());},[x,E]),S=useCallback(()=>{x&&(v(false),E().onClose?.());},[x,E]),ye=useCallback(()=>{S(),E().onCloseComplete?.();},[S,E]),q=useCallback(()=>{x?S():N();},[x,N,S]),ee=useCallback(R=>w.current&&!w.current.contains(R)&&A.current&&!A.current.contains(R),[]),$=useCallback(R=>{(u||c!==false&&ee(R.target))&&(S(),p&&R.stopPropagation());},[u,c,ee,S,p]),L=useCallback(R=>{m!==false&&["Escape","Esc"].indexOf(R.key)>-1&&S();},[m,S]);useEffect(()=>{typeof e=="boolean"&&e!==x&&(e?N():S());},[e,x,N,S]),useEffect(()=>(x&&(document.addEventListener("click",$,!!p),document.addEventListener("keydown",L,!!p)),()=>{document.removeEventListener("click",$,!!p),document.removeEventListener("keydown",L,!!p);}),[x,$,L,p]);let Vt=useCallback(({ref:R,show:te,flipped:$e})=>{if(typeof a=="function")return a({ref:Le([R,w]),show:te,flipped:$e,toggle:q});let Q=a.props;return cloneElement(a,{ref:Le([R,w,Q.ref]),role:"button","aria-expanded":te,"aria-haspopup":true,onClick:()=>{q(),typeof Q.onClick=="function"&&Q.onClick();}})},[a,q]),Nt=useCallback(({ref:R,state:te,flipped:$e,zIndex:Q})=>jsx($r,{role:"dialog",...l,"data-state":te,ref:Le([R,A]),zIndex:Q,"data-test":P,children:typeof s=="function"?s({close:S,flipped:$e}):s}),[s,l,S,P]),{animation:Ae}=useTheme(),Gt=useMemo(()=>ur.from(Ae.duration.popover),[Ae.duration.popover]);return jsxs(Fragment,{children:[jsx(it,{isActive:!!(f&&e)}),jsx(ht,{show:typeof e=="boolean"?e:x,animationDuration:Gt,useSmartAlignment:n,alignment:o,target:Vt,onOpenComplete:T.onOpenComplete,onCloseComplete:ye,targetOffset:i,bodyOffset:r,zIndexLayer:h,children:Nt})]})}var $r=V.div`
  z-index: ${e=>e.zIndex};
  position: fixed;
  transform: scale(0.9) translateY(-1px);
  opacity: 0;
  visibility: hidden;
  transition-property: opacity, transform;
  transition-duration: ${e=>e.theme.animation.duration.popover};
  transition-timing-function: ${e=>e.theme.animation.easing.spring};

  &[data-state='entering'],
  &[data-state='entered'] {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
  }

  &[data-state='exiting'] {
    opacity: 0;
    visibility: visible;
    transform: scale(1);
  }
`,le=memo(yr);function vr({size:e$1="m",borderType:t="round",icon:o,iconColor:n,iconSize:i,...r},a){return jsx(Br,{ref:a,type:"button",size:e$1,borderType:t,...r,children:jsx(e,{size:i??"lg",name:o,color:n})})}var se=forwardRef(vr),wr=css`
  height: ${e=>e.height?e.height:e.size==="m"?e.theme.fieldHeight.m:e.theme.fieldHeight.s};
  width: ${e=>e.size==="m"?e.theme.fieldHeight.m:e.theme.fieldHeight.s};
  border-radius: ${e=>e.borderType==="round"||e.borderType==="none-round"?"50%":e.theme.borderRadius.s};
  background-color: ${e=>e.iconBackgroundColor?e.theme.colors[e.iconBackgroundColor]:e.theme.colors.iconBackground};
  color: ${e=>e.theme.colors.primaryFont};
  background-clip: padding-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  flex: 0 0 auto; // Don't shrink or grow inside flex display by default

  &:hover {
    background-color: ${e=>e.hoverIconBackgroundColor?e.theme.colors[e.hoverIconBackgroundColor]:e.theme.colors.secondaryBackground};
  }
  &:active {
    background-color: ${e=>e.theme.colors.info};
    border-color: ${e=>e.theme.colors.borderHover};
  }
  &:focus-visible {
    outline: ${e=>e.theme.colors.borderFocus} auto ${e=>e.theme.borderWidth.s};
  }
`,Br=V.button`
  ${wr};
  border-width: ${e=>e.borderType==="round"||e.borderType==="square"?e.theme.borderWidth.s:e.theme.borderWidth.none};
  border-color: ${e=>e.iconBorderColor?e.theme.colors[e.iconBorderColor]:e.theme.colors.borders};
  border-style: solid;
  cursor: pointer;

  // Need to use '&&' to increase specificity so that the background color and border color
  // do not apply when the button is disabled.
  &&:disabled {
    background-color: ${e=>e.theme.colors.iconBackground};
    border-color: ${e=>e.iconBorderColor?e.theme.colors[e.iconBorderColor]:e.theme.colors.borders};
    opacity: 0.5;
    cursor: not-allowed;
  }
`;var He=defineMessages({noItemsLabel:{id:"uikit.menu.noItemsLabel",defaultMessage:"No items"},toggleAriaLabel:{id:"uikit.menu.toggleAriaLabel",defaultMessage:"Toggle menu"}});function O({children:e,onClick:t,...o}){return jsx("div",{...o,children:e})}function ce({anchor:e=jsx(se,{borderType:"none-round",icon:"VMSWeb-more-vertical"}),anchorRef:t,disabled:o=false,useSmartAlignment:n=true,contentProps:i,alignment:r="bottom",onOpen:a,onClose:s,children:l,scrollLock:u,targetOffset:c,rowsStyles:m,"data-test":p,width:h,...f}){let P=useTheme(),{formatMessage:T}=useLocales(),x=useRef(null),v=Y.Children.toArray(l).filter($=>Y.isValidElement($)),{isOpen:w,highlightedIndex:A,getMenuProps:E,getItemProps:N,getToggleButtonProps:S}=useSelect({items:v.filter($=>$.type===O),circularNavigation:true,onSelectedItemChange:({selectedItem:$})=>{x.current?.blur(),$?.props.onClick?.();}}),ye=useCallback($=>Y.cloneElement(e,{...f,disabled:o,"data-test":p,"aria-label":T(He.toggleAriaLabel),...S({ref:t?Le([$.ref,t]):$.ref})}),[e,f,t,o,T,S,p]),q=E({ref:x},{suppressRefError:true}),ee=()=>{let $=-1;return jsxs(Fr,{rowsStyles:m,width:h,...q,children:[v.map(L=>L.type===O?($+=1,jsx(Ar,{label:L,highlighted:A===$,"data-test":`menu-row-${L.key}`,...N({item:L,index:$})},L.key)):L),v.length===0&&jsx(ot,{children:T(He.noItemsLabel)})]})};return jsx(le,{targetOffset:Number.parseInt(P.spacing[c??"xs"]),bodyOffset:0,alignment:r,useSmartAlignment:n,show:w,contentProps:i,onOpen:a,onClose:s,onOpenComplete:()=>x.current?.focus(),content:ee,scrollLock:u,children:ye})}var Fr=V(rt)`
  width: ${e=>e.width??"max-content"};
  max-width: 330px;
  border: none;
  border-radius: 4px;
  box-shadow: ${e=>e.theme.shadows.secondary};
  overflow-y: auto;
  ${e=>e.rowsStyles??""}
`,Ar=V(nt)`
  i {
    margin: 0 10px 0 0;
    font-size: ${e=>e.theme.fontSizes.l};
  }
`;var gs=V.hr`
  margin: 0;
  border: none;
  border-top: 1px ${e=>e.theme.colors.dividerLines} solid;
`;function St({children:e$1,...t}){let o=e$1&&Y.Children.map(e$1,n=>jsxs(O,{onClick:n.props.onClick,"data-test":n.props["data-test"],children:[n.props.iconName&&jsx(e,{name:n.props.iconName}),n.props.text&&jsx(y,{children:n.props.text}),n.props.children]},n.key));return jsx(ce,{...t,children:o})}(t=>{function e(o){return jsx("div",{})}t.PopoverItem=e;})(St||={});function Yr({children:e,isExternal:t=false,type:o="button",fontSize:n,...i},r){let a=!i.disabled&&i.href;return jsx(Ur,{ref:r,...i,$fontSize:n,...a?{as:Link,to:i.href,isExternal:t}:{type:o},children:e})}var k=Y.forwardRef(Yr),Ur=V.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.$fontSize?e.theme.fontSizes[e.$fontSize]:e.theme.fontSizes.m};
  outline: 0;
  cursor: pointer;
  color: inherit;
  background: transparent;
  white-space: nowrap;
  text-decoration: none !important;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  border: none;

  ${e=>e.fullWidth&&css`
      width: 100%;
    `}
`;function qr({children:e$1,icon:t,size:o="m",variant:n="primary",disabled:i,...r},a){return jsxs(Qr,{ref:a,size:o,variant:n,icon:t,disabled:i,...r,children:[t?jsx(g,{mr:"s",children:jsx(e,{size:"lg",name:t})}):null,e$1]})}var I=Y.forwardRef(qr);function J(e){return e.noPadding?"0":e.size==="m"?e.icon?"0 24px 0 18px":"0 24px 0 24px":e.icon?"0 16px 0 10px":"0 16px 0 16px"}var Qr=V(k)`
  ${e=>e.variant==="primary"&&css`
      height: ${e.theme.fieldHeight[e.size??"s"]};
      padding: ${J(e)};
      border-radius: ${e.theme.borderRadius[e.borderRadius??"s"]};
      color: ${e.theme.button.primary.textColor} !important;
      background-color: ${e.theme.button.primary.backgroundColor};
      border: 1px solid ${t=>t.theme.button.primary.borderColor};

      &:focus:not(:focus-visible) {
        /* this and :focus styles are for fallback IE11 and Safari */
        background-color: ${e.theme.button.primary.backgroundColor};
        border-color: ${t=>t.theme.button.primary.borderColor};
      }

      &:focus,
      &:hover {
        background-color: ${e.theme.button.primary.hover.backgroundColor};
        border-color: ${t=>t.theme.button.primary.hover.borderColor};
      }

      &:focus-visible {
        background-color: ${e.theme.button.primary.hover.backgroundColor};
        border-color: ${t=>t.theme.button.primary.hover.borderColor};
      }

      &:disabled {
        background-color: ${e.theme.button.primary.disabled.backgroundColor} !important;
        border-color: ${t=>t.theme.button.primary.disabled.borderColor} !important;
        color: ${t=>t.theme.button.primary.disabled.textColor} !important;
        cursor: not-allowed;
      }
    `};

  ${e=>e.variant==="primary-warning"&&css`
      height: ${e.theme.fieldHeight[e.size??"s"]};
      padding: ${J(e)};
      border-radius: ${e.theme.borderRadius[e.borderRadius??"s"]};
      color: ${e.theme.button.primaryWarning.textColor} !important;
      background-color: ${e.theme.button.primaryWarning.backgroundColor};
      border: 1px solid ${t=>t.theme.button.primaryWarning.borderColor};

      &:focus:not(:focus-visible) {
        /* this and :focus styles are for fallback IE11 and Safari */
        background-color: ${e.theme.button.primaryWarning.backgroundColor};
        border-color: ${t=>t.theme.button.primaryWarning.borderColor};
      }

      &:focus,
      &:hover {
        background-color: ${e.theme.button.primaryWarning.hover.backgroundColor};
        border-color: ${t=>t.theme.button.primaryWarning.hover.borderColor};
      }

      &:focus-visible {
        background-color: ${e.theme.button.primaryWarning.hover.backgroundColor};
        border-color: ${t=>t.theme.button.primaryWarning.hover.borderColor};
      }

      &:disabled {
        color: ${e.theme.button.primaryWarning.disabled.textColor} !important;
        background-color: ${e.theme.button.primaryWarning.disabled.backgroundColor} !important;
        border-color: ${t=>t.theme.button.primaryWarning.disabled.borderColor} !important;
        cursor: not-allowed;
      }
    `};

  ${e=>e.variant==="secondary"&&css`
      height: ${e.theme.fieldHeight[e.size??"s"]};
      padding: ${J(e)};
      border-radius: ${e.theme.borderRadius[e.borderRadius??"s"]};
      color: ${e.theme.button.secondary.textColor} !important;
      background-color: ${e.theme.button.secondary.backgroundColor};
      border: 1px solid ${e.theme.button.secondary.borderColor};

      &:focus:not(:focus-visible) {
        /* this and :focus styles are for fallback IE11 and Safari */
        background-color: ${e.theme.button.secondary.hover.backgroundColor};
        color: ${e.theme.button.secondary.textColor} !important;
        border-color: ${e.theme.button.secondary.borderColor};
      }

      &:focus,
      &:hover {
        background-color: ${e.theme.button.secondary.hover.backgroundColor};
        color: ${e.theme.button.secondary.hover.textColor} !important;
        border-color: ${e.theme.button.secondary.hover.borderColor};
      }

      &:focus-visible {
        background-color: ${e.theme.button.secondary.hover.backgroundColor};
        color: ${e.theme.button.secondary.hover.textColor} !important;
        border-color: ${e.theme.button.secondary.hover.borderColor};
      }

      &:disabled {
        color: ${e.theme.button.secondary.disabled.textColor} !important;
        border-color: ${e.theme.button.secondary.disabled.borderColor} !important;
        cursor: not-allowed;
      }
    `};

  ${e=>e.variant==="secondary-warning"&&css`
      height: ${e.theme.fieldHeight[e.size??"s"]};
      padding: ${J(e)};
      border-radius: ${e.theme.borderRadius[e.borderRadius??"s"]};
      color: ${t=>t.theme.button.secondaryWarning.textColor} !important;
      background-color: ${t=>t.theme.button.secondaryWarning.backgroundColor};
      border: 1px solid ${t=>t.theme.button.secondaryWarning.borderColor};

      &:focus:not(:focus-visible) {
        /* this and :focus styles are for fallback IE11 and Safari */
        color: ${t=>t.theme.button.secondaryWarning.textColor} !important;
        border-color: ${t=>t.theme.button.secondaryWarning.borderColor};
      }

      &:focus,
      &:hover {
        color: ${t=>t.theme.button.secondaryWarning.hover.textColor} !important;
        border-color: ${t=>t.theme.button.secondaryWarning.hover.borderColor};
      }

      &:focus-visible {
        color: ${e.theme.button.secondaryWarning.hover.textColor} !important;
        border-color: ${t=>t.theme.button.secondaryWarning.hover.borderColor};
      }

      &:disabled {
        color: ${e.theme.button.secondaryWarning.disabled.textColor} !important;
        border-color: ${t=>t.theme.button.secondaryWarning.disabled.borderColor} !important;
        cursor: not-allowed;
      }
    `};

  ${e=>e.variant==="tertiary"&&css`
      padding: ${J(e)};
      border-radius: ${e.theme.borderRadius[e.borderRadius??"s"]};
      color: ${t=>t.theme.button.tertiary.textColor} !important;
      background-color: ${t=>t.theme.button.tertiary.backgroundColor};
      border: 1px solid ${t=>t.theme.button.tertiary.borderColor};

      &:focus:not(:focus-visible) {
        /* this and :focus styles are for fallback IE11 and Safari */
        color: ${e.theme.button.tertiary.textColor};
      }

      &:focus,
      &:hover {
        color: ${e.theme.button.tertiary.hover.textColor} !important;
        text-decoration: ${e.theme.button.tertiary.hover.textDecoration} !important;
      }

      &:focus-visible {
        color: ${e.theme.button.tertiary.hover.textColor} !important;
        text-decoration: ${e.theme.button.tertiary.hover.textDecoration} !important;
      }

      &:disabled {
        color: ${e.theme.button.tertiary.disabled.textColor} !important;
        cursor: not-allowed;
      }
    `};

  ${e=>e.variant==="tertiary-warning"&&css`
      padding: 0;
      border-radius: ${e.theme.borderRadius[e.borderRadius??"s"]};
      color: ${t=>t.theme.button.tertiaryWarning.textColor} !important;
      background-color: ${t=>t.theme.button.tertiaryWarning.backgroundColor};
      border: 1px solid ${t=>t.theme.button.tertiaryWarning.borderColor};

      &:focus:not(:focus-visible) {
        /* this and :focus styles are for fallback IE11 and Safari */
        color: ${e.theme.button.tertiaryWarning.textColor} !important;
      }

      &:focus,
      &:hover {
        color: ${e.theme.button.tertiaryWarning.hover.textColor} !important;
      }

      &:focus-visible {
        color: ${e.theme.button.tertiaryWarning.hover.textColor} !important;
      }

      &:disabled {
        color: ${e.theme.button.tertiaryWarning.disabled.textColor} !important;
        cursor: not-allowed;
      }
    `};

  ${e=>e.textWrap&&css`
      text-wrap: ${e.textWrap};
    `};
`;function Zs({variant:e$1="primary",size:t,actions:o,menuWidth:n,...i}){let[r,a]=useState(false),s=o[0],l=o.slice(1);return s==null?null:jsxs(M,{children:[jsx(jr,{variant:e$1,size:t,...i,onClick:s.onClick,children:s.title}),jsx(ce,{onOpen:()=>a(true),onClose:()=>a(false),alignment:"bottomRight","data-test":"sr-actions-button-menu",anchor:jsx(en,{"data-test":"sr-actions-button-menu-button",variant:e$1,size:t,children:jsx(e,{name:r?"VMSWeb-chevron-up":"VMSWeb-chevron-down"})}),disabled:i.disabled,width:n,children:l.map(u=>{let{title:c,id:m,...p}=u;return jsx(O,{...p,onClick:()=>u.onClick(),children:c},m)})})]})}var jr=V(I)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`,en=V(I)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0;
  margin-left: ${e=>e.theme.spacing.xs};
  min-width: 30px;
`;function td({children:e,...t}){return jsx(rn,{fullWidth:true,...t,children:e})}var rn=V(k)`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border-radius: ${e=>e.theme.borderRadius.s};
  border: 1px solid ${e=>e.theme.colors.secondaryBackground};
  background-color: ${e=>e.theme.colors.secondaryBackground};

  &:hover:not(:disabled) {
    background-color: ${e=>e.theme.colors.inputHoverBackground};
    border-color: ${e=>e.theme.colors.inputHoverBackground};
  }

  &:focus {
    background-color: ${e=>e.theme.colors.inputHoverBackground};
    border-color: ${e=>e.theme.colors.borderFocus};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;function an({collapsed:e,onClick:t,onToggle:o,collapseIcon:n="chevron",...i},r){return jsx(se,{"data-test":e?"ui-kit__collapse-button__chevron-down":"ui-kit__collapse-button__chevron-up",...i,ref:r,"aria-label":e?"expand":"collapse",borderType:"none-round",icon:e?`VMSWeb-${n==="chevron"?"chevron-down":"add"}`:`VMSWeb-${n==="chevron"?"chevron-up":"minus"}`,onClick:a=>{t?.(a),o?.(!e);}})}var ld=Y.forwardRef(an);function ue({title:e,displayAction:t="click",content:o,show:n,disabled:i,children:r,...a}){let[s,l]=useState(n),u=m=>{m.target.tagName==="BUTTON"&&l(false);},c=m=>()=>{l(m&&!i);};return jsx(le,{...a,show:s,content:jsx("div",{onClick:u,onKeyUp:u,children:jsx(cn,{p:"m",children:jsxs(Fragment,{children:[e&&jsx(g,{mb:"m",children:jsx(Ze,{type:"h3",color:"lightFont",children:e})}),o]})})}),children:t==="hover"?jsx(g,{onMouseEnter:c(true),onMouseLeave:c(false),children:r}):r})}var cn=V(g)`
  max-width: 400px;
  background-color: ${e=>e.theme.colors.primaryNavigation};
  border-radius: 4px;
  color: white;
  font-size: ${e=>e.theme.fontSizes.m};
  font-family: ${e=>e.theme.fonts.primary};
`;function hn({iconName:e$1,tooltip:t,...o},n){let{formatMessage:i}=useLocales();return jsx(ue,{...t,children:jsx(k,{ref:n,"aria-label":i(commonMessages.additionalInformation),fontSize:"l",...o,children:jsx(e,{name:e$1??"VMSWeb-info"})})})}var Rd=Y.forwardRef(hn);function Hd({children:e,loading:t,disabled:o,...n}){return jsx(xn,{...n,$loading:t,disabled:t||o,variant:"primary",children:jsx(gn,{children:e})})}var gn=V.div`
  z-index: 0;
`,xn=V(I)`
  ${e=>e.$loading&&css`
      &:disabled {
        position: relative;
        border-color: ${t=>t.theme.button.primary.borderColor};
        color: ${t=>t.theme.button.primary.textColor} !important;
        overflow: hidden;
        background: none;
        cursor: progress;
      }
      &:before {
        content: '';
        position: absolute;
        display: block;
        left: -46px;
        top: 0;
        bottom: 0;
        right: 0;
        animation: stripes-move 0.5s infinite linear;
        background: repeating-linear-gradient(
          -55deg,
          ${e.theme.colors.primaryButton} 1px,
          ${e.theme.colors.primaryHover} 2px,
          ${e.theme.colors.primaryHover} 11px,
          ${e.theme.colors.primaryButton} 12px,
          ${e.theme.colors.primaryButton} 40px
        );
      }
    `}

  @keyframes stripes-move {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(46px);
    }
  }
`;function Vd({children:e$1,disabled:t,icon:o,...n}){return jsxs($n,{...n,disabled:t,variant:"secondary",children:[o?jsx(g,{mr:"xs",children:jsx(e,{size:"sm",name:o})}):null,e$1]})}var $n=V(I)`
  height: ${e=>e.theme.spacing.lm};
  line-height: ${e=>e.theme.spacing.lm};
  border-radius: ${e=>e.theme.spacing.sm};
  border-color: ${e=>e.theme.colors.primaryButton};
  color: ${e=>e.theme.colors.primaryButton} !important;
  background: ${e=>e.theme.colors.primaryBackground};
  font-size: ${e=>e.theme.fontSizes.s};
  padding: ${e=>e.theme.spacing.xs} ${e=>e.theme.spacing.s};
`;function cc({"data-test":e$1,children:t,variant:o,icon:n,info:i,...r}){return jsxs(Cn,{"data-test":e$1,inline:true,variant:o,justifyContent:"center",alignItems:"center",...r,children:[n&&jsx(g,{pr:"xs",children:jsx(e,{name:n})}),t,i&&jsx(g,{pl:"xs",children:jsx(ue,{content:i,children:jsx(k,{"aria-label":"Additional Information",children:jsx(e,{name:"VMSWeb-info"})})})})]})}var Cn=V(M)`
  font-size: ${e=>e.theme.fontSizes.m};
  font-family: ${e=>e.theme.fonts.primary};
  min-height: 22px;
  border-radius: 4px;
  box-sizing: border-box;
  padding-left: ${e=>e.theme.spacing.xs};
  padding-right: ${e=>e.theme.spacing.xs};
  line-height: ${e=>e.theme.lineHeights.s};
  background: ${e=>`linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${e.theme.colors[e.variant]}`};
  color: ${e=>e.theme.colors[e.variant]};
  border: ${e=>`1px solid ${transparentize(.5,e.theme.colors[e.variant])}`};
`;function kn({absolute:e,placeholder:t,selectedValue:o,inputValue:n,...i}){return jsx(Ee,{absolute:!!e,hasValue:!!o,...i,children:!n&&(o??t)})}var Ee=V.div`
  pointer-events: none;
  user-select: none;
  width: 100%;
  box-sizing: border-box;
  padding-right: ${e=>e.theme.spacing.s};
  line-height: 18px;
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  color: ${e=>e.hasValue?e.theme.colors.primaryFont:e.theme.colors.secondaryFont};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${e=>e.absolute&&css`
      position: absolute;
    `}
`;function Ln({value:e$1="",placeholder:t,searchable:o,selectedValue:n,hidden:i,filterIcon:r,valueIcon:a,hideFilterIcon:s,displayValue:l,...u},c){let m=useRef(null);useLayoutEffect(()=>{m.current&&m.current.value!==e$1&&o&&(m.current.value=e$1);},[e$1]);let h=s?null:r||(o?jsx(e,{name:"VMSWeb-search"}):null);return jsxs(In,{visuallyHidden:!!i,children:[h,a&&jsx(Hn,{children:a}),!a&&jsxs(Mn,{hasIcon:!!h,children:[jsx(kn,{absolute:true,inputValue:o?e$1:undefined,placeholder:t||(o?"Search an option":"Choose an option"),selectedValue:l??n}),jsx(It,{...u,ref:Le([c,m]),value:undefined,readOnly:!o,searchable:o})]})]})}var It=V.input`
  box-sizing: border-box;
  margin: 0;
  outline: 0;
  width: 100%;
  border: none;
  background: transparent none;
  box-shadow: none;
  cursor: ${e=>e.searchable?"":"pointer"};
  line-height: 18px;
  font-family: ${e=>e.theme.fonts.primary};
  color: ${e=>e.theme.colors.primaryFont};
  font-size: ${e=>e.theme.fontSizes.m};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &::-ms-clear {
    display: none;
  }
`,Mn=V.div`
  position: relative;
  width: 100%;

  ${Ee}, ${It} {
    padding: 11px 0 11px ${e=>e.hasIcon?"50px":"16px"};
  }
`,Hn=V.div`
  position: relative;
  width: 16px;
`,In=V.div`
  flex: 1;
  align-items: center;
  position: relative;
  ${e=>e.visuallyHidden&&fe}
  cursor: pointer;

  > i {
    margin: 0 18px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: ${e=>e.theme.fontSizes.l};
    color: ${e=>e.theme.colors.primaryIcons};
  }
`,yc=forwardRef(Ln);function En(e,t){return jsx(Wn,{ref:t,...e})}var Wn=V.div`
  --border-color: ${e=>e.theme.colors.borders};
  width: ${e=>e.width||"100%"};
  display: flex;
  flex-direction: ${e=>e.multiValue?"column":"row"};
  min-height: ${e=>e.theme.fieldHeight.m};
  box-sizing: border-box;
  background: ${e=>e.valueIcon?"none":e.theme.colors.inputBackground};
  border-radius: ${e=>{let t=e.theme.borderRadius.s;return e.open?e.flipped?`0 0 ${t} ${t}`:`${t} ${t} 0 0`:t}};
  border: ${e=>e.valueIcon?"none":`1px solid ${e.open||e.focused?e.theme.colors.borderFocus:"var(--border-color)"}`};
  transition: border ${e=>e.theme.animation.duration.controls} ease,
    border-radius ${e=>e.theme.animation.duration.controls} ease;

  &:hover {
    border-color: ${e=>e.open||e.focused?e.theme.colors.borderFocus:e.theme.colors.borderHover};
  }

  ${e=>e.disabled&&css`
      ${Ee} {
        color: ${e.theme.colors.secondaryFont};
      }

      background-color: ${e.theme.colors.secondaryBackground};
      cursor: not-allowed;

      * {
        pointer-events: none;
      }
    `}

  ${e=>e.invalid&&css`
      border-color: ${e.theme.colors.error};
    `}
`,$c=forwardRef(En),fe=css`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: fixed;
  white-space: nowrap;
  width: 1px;
`,Sc=V.label`
  ${fe}
`;function On({children:e$1,onSelectionChange:t,onClearClick:o,onClick:n,icon:i,selected:r,disabled:a,...s},l){let u=We.isFunction(o),c=We.isFunction(t),m=We.isFunction(n),p=useCallback(f=>{f.stopPropagation(),f.nativeEvent.stopImmediatePropagation(),n?.(f);},[n]),h=useCallback(f=>{f.stopPropagation(),f.nativeEvent.stopImmediatePropagation(),o?.(f);},[o]);return jsxs(Dn,{selectable:c,clickable:m,selected:r,disabled:a,clearable:u,...s,onClick:p,ref:l,children:[i&&jsx(g,{mr:"xs",children:jsx(e,{name:i})}),e$1,u&&jsx(g,{ml:"xs",children:jsx(k,{onClick:h,disabled:a,"data-test":"clear-button","aria-label":"clear",children:jsx(e,{name:"VMSWeb-close-circle-outline"})})}),c&&jsx(g,{ml:"xs",children:jsx(k,{"data-test":"select-button","aria-label":"select",onClick:()=>{t&&t(!r);},disabled:a,children:jsx(e,{name:r?"VMSWeb-checkbox-marked-circle":"VMSWeb-checkbox-blank-circle-outline"})})})]})}var Ic=forwardRef(On),Dn=V.div`
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding-left: 8px;
  padding-right: 8px;
  margin-right: ${e=>e.theme.spacing.xs};
  margin-top: ${e=>e.theme.spacing.xs};
  border-radius: ${e=>e.theme.tag.borderRadius};
  background-color: ${e=>e.backgroundColor};
  font-family: ${e=>e.theme.fonts.primary};
  color: ${e=>g$1(e.backgroundColor,e.theme.colors.lightFont,e.theme.colors.darkFont)};
  font-size: ${e=>e.theme.fontSizes.m};

  ${e=>(e.selectable||e.clearable||e.clickable)&&css`
      &:hover {
        background-color: ${e.disabled?e.backgroundColor:darken(.1,e.backgroundColor)};
      }
    `}

  ${e=>e.disabled&&css`
      opacity: 0.5;
    `};

  ${e=>(e.selectable||e.clickable)&&css`
      cursor: pointer;
    `};

  ${e=>e.hidden&&fe}
`;function Gn(e,t){return jsx(_n,{...e,ref:t})}var be=Y.forwardRef(Gn),_n=V(M)`
  ${e=>e.flexDirection==="column"&&e.spacing&&css`
      && > * {
        margin-bottom: ${e.theme.spacing[e.spacing]};
      }

      && > *:last-child {
        margin-bottom: 0;
      }
    `}

  ${e=>e.flexDirection==="column-reverse"&&e.spacing&&css`
      && > * {
        margin-top: ${e.theme.spacing[e.spacing]};
      }

      && > *:last-child {
        margin-top: 0;
      }
    `}

    ${e=>e.flexDirection==="row"&&e.spacing&&css`
      && > * {
        margin-right: ${e.theme.spacing[e.spacing]};
      }

      && > *:last-child {
        margin-right: 0;
      }
    `}

    ${e=>e.flexDirection==="row-reverse"&&e.spacing&&css`
      && > * {
        margin-left: ${e.theme.spacing[e.spacing]};
      }

      && > *:last-child {
        margin-left: 0;
      }
    `}
`;function qn({breakpoint:e="s",children:t,...o},n){let i=useTheme(),r=useMediaQuery(`(max-width:${i.breakpoints[e]}px)`);return jsx(be,{flexDirection:r?"column":"row",...o,ref:n,children:t})}var Xc=forwardRef(qn);function Kn(e,t){return jsx(be,{...e,ref:t,flexDirection:"column"})}var Fe=Y.forwardRef(Kn);function um({message:e,hasBlockHtmlElements:t=false,textOverflow:o=3,spacing:n="m",viewMoreButtonText:i="View more",viewLessButtonText:r="View less",dataTest:a="auto-truncating-text",alignItems:s="flex-start",...l}){return t?jsx(ti,{message:e,textOverflow:o,spacing:n,viewMoreButtonText:i,viewLessButtonText:r,dataTest:a,alignItems:s,...l}):jsx(ei,{message:e,textOverflow:o,spacing:n,viewMoreButtonText:i,viewLessButtonText:r,dataTest:a,alignItems:s,...l})}function ei({message:e,textOverflow:t,spacing:o,viewMoreButtonText:n,viewLessButtonText:i,dataTest:r$1,alignItems:a,...s}){let[l,u]=useState(false),[c,{height:m}]=q({scroll:false,offsetSize:false}),[p,h]=r(m);return jsxs(Fe,{spacing:o,alignItems:a,children:[jsx(y,{"data-test":r$1,ref:Le([c,h]),textOverflow:l?undefined:t,...s,children:e}),p&&jsx(xe,{noPadding:true,"data-test":`${r$1}-show-more-button`,variant:"tertiary",onClick:()=>{u(true);},children:n}),l&&jsx(xe,{noPadding:true,"data-test":`${r$1}-show-less-button`,variant:"tertiary",onClick:()=>{u(false);},children:i})]})}function ti({message:e,textOverflow:t,spacing:o,viewMoreButtonText:n,viewLessButtonText:i,dataTest:r$1,alignItems:a,...s}){let[l,u]=useState(),[c,m]=useState(true),[p,{height:h}]=q({scroll:false,offsetSize:false}),[f,P]=r(h),[T]=useState(()=>{let x;switch(t){case "ellipsis":x=1;break;case "twoLinesEllipsis":x=2;break;default:x=t;}return x});return useEffect(()=>{h!==0&&l===undefined&&(u(f),m(f));},[f,h]),jsxs(Fe,{spacing:o,alignItems:a,children:[jsx(oi,{"data-test":r$1,ref:Le([p,P]),$lineClamp:c?T:undefined,isSafari:x,...s,children:e}),f&&c&&l&&jsx(xe,{noPadding:true,"data-test":`${r$1}-show-more-button`,variant:"tertiary",onClick:()=>{m(false);},children:n}),!c&&l&&jsx(xe,{noPadding:true,"data-test":`${r$1}-show-less-button`,variant:"tertiary",onClick:()=>{m(true);},children:i})]})}var oi=V(y)`
  p {
    /* Our editor use p tag as a line breaker. By default it has margins */
    margin: 0;
  }

  ${e=>e.$lineClamp&&css`
      @supports (-webkit-line-clamp: ${e.$lineClamp}) {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: ${e.$lineClamp};
        -webkit-box-orient: vertical;
      }
    `}

  /* CSS styles only for Safari (Handle case when there are more than one block element on Safari)
     https://stackoverflow.com/questions/70897195/line-clamp-webkit-not-working-in-safari
     Need to check behavior after safari 18.2 will be released (additional support for line clamp property)
     If line clamp property will be fully supported, this block of code can be removed.
  */
  ${e=>e.$lineClamp&&e.isSafari&&css`
      * {
        display: inline;
      }

      p:not(:last-child),
      br:not(:last-child),
      div:not(:last-child),
      h1:not(:last-child),
      h2:not(:last-child),
      h3:not(:last-child),
      h4:not(:last-child),
      h5:not(:last-child),
      h6:not(:last-child),
      section:not(:last-child) {
        &::after {
          content: ' \\A';
          white-space: pre;
        }
      }
    `}
`,xe=V(I)`
  white-space: normal;
  word-break: break-word;
`;

export { Ee as $, ce as A, Ar as B, gs as C, St as D, k as E, Ur as F, I as G, Zs as H, td as I, rn as J, ld as K, ro as L, Ze as M, ue as N, Rd as O, Hd as P, Vd as Q, qe as R, _i as S, ni as T, Ki as U, ea as V, yo as W, sa as X, Ga as Y, Ja as Z, cc as _, g as a, It as aa, C as b, Mn as ba, ga as c, In as ca, Ta as d, yc as da, y as e, Wn as ea, Ye as f, $c as fa, Ue as g, fe as ga, Qt as h, Sc as ha, pi as i, Ic as ia, $i as j, um as ja, M as k, be as l, Xc as m, Fe as n, ot as o, rt as p, nt as q, it as r, lt as s, at as t, st as u, ht as v, le as w, se as x, wr as y, O as z };
